class StackSortingModel{
    constructor(data) {
        this.dragMap = new Map();
        this.dropMap = new Map();
    }

    addDragProxy(drag){
        this.dragMap.set(drag.id,drag)
    }

    addDropProxy(drop){
        this.dropMap.set(drop.id,drop)
    }

    getDragProxy(id){
        return this.dragMap.get(id)
    }

    getDropProxy(id){
        return this.dropMap.get(id);
    }
    getDropMap() {
        return this.dropMap;
    }
    getDragMap() {
        return this.dragMap;
    }

}

export default StackSortingModel;